<script setup lang="ts">
   defineProps<{
      title: string;
   }>();
</script>

<template>
   <div class="mx-auto flex max-w-3xl items-center gap-4 px-4">
      <div class="wow-heading-line h-px flex-1"></div>
      <h2 class="text-center text-xl font-bold uppercase tracking-wide text-gray-900">
         {{ title }}
      </h2>
      <div class="wow-heading-line h-px flex-1"></div>
   </div>
</template>

<style scoped>
   .wow-heading-line {
      background-color: #7cdfef;
   }
</style>
